import { createContext, ReactNode, useContext } from "react";

import { useFilterQuotation } from "./filter-quotation.hook";

const FilterQuotationContext = createContext(
  {} as ReturnType<typeof useFilterQuotation>
);
export function useFilterQuotationContext() {
  return useContext(FilterQuotationContext);
}

interface FilterQuotationProviderProps {
  children: ReactNode;
}
export function FilterQuotationProvider({
  children,
}: FilterQuotationProviderProps) {
  return (
    <FilterQuotationContext.Provider value={useFilterQuotation()}>
      {children}
    </FilterQuotationContext.Provider>
  );
}